// import { useUserTransactionsStore } from "store/userTransaction/useUserTransactionsStore";
// import { useWalletStore } from "store/wallet/useWalletStore";
import { AuthStorage } from "services/auth/AuthStorage";
import { SessionManager } from "../../auth/sessionManager";
import userHttp from "../../axios.services/instances/userHttp";
import {
  normalizeApiResponse,
  ServiceCallResult,
} from "../cashQuinHttpResponse/cashQuinHttpResponse";
import {
  LoginRequestDto,
  LoginResponseDto,
  RegisterRequestDto,
  RegisterSuccessDto,
  VerifyOtpRequestDto,
  VerifyOtpResponseDto,
  SendOtpRequestDto,
  SendOtpResponseDto
} from "./userServiceType";

const userService = {
  login: async (
    payload: LoginRequestDto,
  ): Promise<ServiceCallResult<LoginResponseDto>> => {
    const loginRes = await userHttp.post("/api/v1/auth/login", {
      mobileNumber: payload.mobileNumber,
      // password: payload.password,
    });

    const api = normalizeApiResponse<LoginResponseDto>(loginRes, loginRes.status);
    if (!api.status) {
         return {
        ok: false,
        statusCode: api.statusCode,
        message: api.message || "Login failed",
        errors: api.errors,
        raw: api,
      };
    }
    return { ok: true, value: api.data as LoginResponseDto, raw: api };
  },

  sendOtp: async (
    payload: SendOtpRequestDto,
  ): Promise<ServiceCallResult<SendOtpResponseDto>> => {
    const res = await userHttp.post("/api/v1/otp/send", payload);
    const api = normalizeApiResponse<SendOtpResponseDto>(res, res.status);
    if (!api.status) {
         return {
        ok: false,
        statusCode: api.statusCode,
        message: api.message || "Sending OTP failed",
        errors: api.errors,
        raw: api,
      };
    }
    return { ok: true, value: api.data as SendOtpResponseDto, raw: api };
  },

  verifyOtp: async (
    payload: VerifyOtpRequestDto,
  ): Promise<ServiceCallResult<VerifyOtpResponseDto>> => {
    const res = await userHttp.post("/api/v1/otp/verify", payload);

    const api = normalizeApiResponse<VerifyOtpResponseDto>(res, res.status);

    if (!api.status || !api.data?.accessToken) {
        return {
          ok: false,
          statusCode: api.statusCode,
          message: api.message || "OTP Verification failed",
          errors: api.errors,
          raw: api,
        };
    }

    const { accessToken, accessExpiresAt, userId, userName, userEmail, userMobile } = api.data;

    // Use expiresAtUtc from api or just default handling
    SessionManager.setAccessToken(accessToken, accessExpiresAt);

    // STORE USER INFO in localStorage (single object)
    AuthStorage.setUser({
      userId: userId || null,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
    });
    
    return { ok: true, value: api.data, raw: api };
  },

  register: async (
    payload: RegisterRequestDto,
  ): Promise<ServiceCallResult<RegisterSuccessDto>> => {
    const req: RegisterRequestDto = {
      ...payload,
    };

    const httpRes = await userHttp.post("/api/register", req);

    const api = normalizeApiResponse<RegisterSuccessDto>(
      httpRes,
      httpRes.status,
    );

    if (!httpRes.status) {
      return {
        ok: false,
        statusCode: api.statusCode,
        message: api.message || "Registration failed",
        errors: api.errors,
        raw: api,
      };
    }
    return { ok: true, value: api.data ?? {}, raw: api };
  },

  fetchSession: async () => {
    const httpRes = await userHttp.get("/session");
    return normalizeApiResponse<unknown>(httpRes.data, httpRes.status);
  },

  logout: async () => {
    SessionManager.clear();
    AuthStorage.clear();
    // useWalletStore.getState().clear();
    // useUserTransactionsStore.getState().clear();

    const httpRes = await userHttp.post("/api/v1/auth/logout");

    return normalizeApiResponse<unknown>(httpRes.data, httpRes.status);
  },
};

export default userService;

// import { SessionManager } from "../../auth/sessionManager";
// import userHttp from "../../axios.services/instances/userHttp";

// export interface RegisterPayload  {
//   email: string;
//   mobile: string;
//   password: string;
//   fullName: string;
//   aadharNumber: string;
//   panNumber: string;
//   address: string;
//   profileImage: string | null;    // base64 string (without data: prefix)
//   imgExtenstion: string;   // e.g. "jpg", "png"

// }

// const userService = {
//   login: async (payload: { email: string; password: string }) => {
//     const response = await userHttp.post("/api/login", {
//       email: payload.email,
//       passwordHash: payload.password,
//     });

//     console.log({ response });

//     const wrapper = response?.data;
//     const inner = wrapper?.Data ?? wrapper;

//     const { token, sessionId, expiresAtUtc, userId, role } = inner;
//     SessionManager.setAuth({ token, sessionId, expiresAtUtc });

//     return { userId, role, token, sessionId, expiresAtUtc };
//   },
//   register: async (payload: RegisterPayload) => {

//     // console.log({payload});

//     const response = await userHttp.post("/api/register", {
//       email: payload.email,
//       mobile: payload.mobile,
//       password: payload.password,
//       fullName: payload.fullName,
//       aadharNumber: payload.aadharNumber,
//       panNumber: payload.panNumber,
//       address: payload.address,
//       profileImage: payload.profileImage,
//       imgExtenstion: payload.imgExtenstion
//     });

//     // console.log({response});

//     const wrapper = response?.data;
//     const inner = wrapper?.Data ?? wrapper;
// // console.log({inner});
//     // assume: { message, userId, ... } aata hai
//     return inner;
//   },

//   fetchSession: async () => {
//     const response = await userHttp.get(`/session`);
//     return response?.data ?? response;
//   },

//   logout: async () => {
//     SessionManager.clear();
//     const response = await userHttp.post(`/logout`);

//     return response?.data ?? response;
//   },
// };

// export default userService;
